import Api from '@/services/Api'

export default {
  index () {
    var results = Api().get('codes') ;
    console.log("In codes service back from server results=" + JSON.stringify(results)) ;
    return results ;
  },
  counts () {
    var results = Api().get('codes/counts') ;
    console.log("In codes counts service back from server results=" + results) ;
    return results ;
  },
  create (code) {
    console.log("in create code") ;
    var results = Api().post('codeCreate', code) ;
    console.log("after create, results=" + results) ;
    return results ;
  },
  edit (code) {
    var results = Api().post('codeUpdate', code) ;
    console.log("after edit, results=" + results) ;
    return results ;
  },
  mergeTo (code) {
    console.log("in mergeTo serviced code=" + JSON.stringify(code)) ;    
    var results = Api().post('codeMergeTo', code) ;
    console.log("after mergeTo, results=" + results) ;
    return results ;
  }    
}



// WEBPACK FOOTER //
// ./src/services/CodeService.js